var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ak-type-input',{attrs:{"hideLabel":"","field":_vm.options},model:{value:(_vm.data.model),callback:function ($$v) {_vm.$set(_vm.data, "model", $$v)},expression:"data.model"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }